export const SET_STEP_LOADING = 'SET_STEP_LOADING';
export const HIDE_STEP_LOADING = 'HIDE_STEP_LOADING';
export const SET_LEAD = 'SET_LEAD';
export const SET_LEAD_LOADING = 'SET_LEAD_LOADING';
export const HIDE_LEAD_LOADING = 'HIDE_LEAD_LOADING';
export const SET_PAGE_INFO = 'SET_PAGE_INFO';
export const RESET_FLOW = 'RESET_FLOW';
export const SET_AUTH = 'SET_AUTH';
export const GO_BACK = 'GO_BACK';
export const TOGGLE_MODAL = 'TOGGLE_MODAL';

